import React from 'react';
import './Refund.css';

const Refund = () => {
  return (
    <div className="refund-page">
      <div className="container">
        <div className="refund-header">
          <h1>Refund & Cancellation Policy</h1>
          <p className="last-updated">Last Updated: December 10, 2024</p>
        </div>

        <div className="refund-content">
          <section className="refund-section">
            <div className="section-number">1</div>
            <div className="section-content">
              <h2>Our Refund Commitment</h2>
              <p>
                At SyarTech, customer satisfaction is our top priority. We are committed to providing high-quality car care services and stand behind our work. If you're not completely satisfied with our service, we offer a fair and transparent refund policy in accordance with Egyptian consumer protection laws.
              </p>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">2</div>
            <div className="section-content">
              <h2>Cancellation Before Service</h2>
              <p>
                You may cancel your appointment at any time before the service starts under the following terms:
              </p>
              <ul>
                <li><strong>Any Time Before Service:</strong> Full refund (100%) to your original payment method</li>
                <li><strong>No Cancellation Fees:</strong> We do not charge cancellation fees regardless of timing</li>
                <li><strong>No-Show:</strong> Full refund issued; however, the incident will be recorded</li>
              </ul>
              <p>
                Refunds are processed within 3-5 business days to your original payment method.
              </p>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">3</div>
            <div className="section-content">
              <h2>Service Quality Guarantee</h2>
              <p>
                If you're not satisfied with the quality of our service, we offer:
              </p>
              <ul>
                <li><strong>Free Re-Service:</strong> Request within 24 hours of service completion</li>
                <li><strong>Partial Refund:</strong> 50% refund if re-service is not satisfactory</li>
                <li><strong>Full Refund:</strong> 100% refund for major service failures</li>
              </ul>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">4</div>
            <div className="section-content">
              <h2>Weather-Related Cancellations</h2>
              <ul>
                <li><strong>Company-Initiated:</strong> Full refund or free rescheduling</li>
                <li><strong>Customer-Initiated:</strong> Free rescheduling or full refund</li>
                <li>No penalties apply for weather-related cancellations</li>
              </ul>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">5</div>
            <div className="section-content">
              <h2>Technician No-Show or Late Arrival</h2>
              <ul>
                <li><strong>No-Show:</strong> Full refund plus service credit</li>
                <li><strong>Significant Delay:</strong> Discount or free rescheduling</li>
                <li><strong>Incomplete Service:</strong> Charged only for completed portions or full refund</li>
              </ul>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">6</div>
            <div className="section-content">
              <h2>Repeated Late Cancellations & Account Warnings</h2>
              <p>
                While SyarTech does not charge cancellation fees, repeated late cancellations or no-shows negatively impact our technicians and service availability.
              </p>
              <ul>
                <li>Accounts with frequent cancellations close to appointment time may receive a warning</li>
                <li>Warnings are issued after multiple incidents within a short period</li>
                <li>Continued misuse may result in temporary booking restrictions</li>
                <li>Severe or repeated abuse may lead to permanent account suspension</li>
                <li>Warnings and restrictions are communicated via app notification</li>
              </ul>
              <p>
                This policy ensures fair access to services for all customers and protects our service providers.
              </p>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">7</div>
            <div className="section-content">
              <h2>Package and Subscription Refunds</h2>
              <ul>
                <li><strong>Within 7 Days:</strong> Full refund if unused</li>
                <li><strong>After Use:</strong> Refund for unused services</li>
                <li><strong>Subscriptions:</strong> Prorated refunds for unused periods</li>
              </ul>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">8</div>
            <div className="section-content">
              <h2>How to Request a Refund</h2>
              <ul>
                <li>Open the SyarTech app</li>
                <li>Go to Order History</li>
                <li>Select the service</li>
                <li>Tap “Request Refund”</li>
              </ul>
              <p>
                Support:
              </p>
              <ul>
                <li>In-app chat (24/7)</li>
                <li>
                  Website: <a href="https://kamshka.com/contact" target="_blank" rel="noopener noreferrer">
                    kamshka.com/contact
                  </a>
                </li>
              </ul>
            </div>
          </section>

          <section className="refund-section">
            <div className="section-number">9</div>
            <div className="section-content">
              <h2>Legal Compliance</h2>
              <p>
                This policy complies with Egyptian Consumer Protection Law No. 181 of 2018 and is governed by Egyptian law.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Refund;
